import _ from 'lodash';
import React from 'react';
import {connect} from 'react-redux';
import {reduxForm, Field} from 'redux-form';
import classNames from 'classnames';

import LabelV2 from 'components/LabelV2';
import FormField from 'components/FormField';
import ErrorBlock from 'components/ErrorBlock';
import {DateField, SelectField, TextField} from 'components/Fields';

import {
  MODALS,
  fetchAllocations,
  fetchAllocationStatistics,
  fetchOfflinePeriodReasons,
  createOfflinePeriod,
  buildOfflinePeriodReasonOption
} from 'ducks/allocations';
import {selectModal, storeDataInModal, closeModal} from 'ducks/modals';
import {requiresPermission, PERMISSIONS} from 'ducks/auth';

import {headOption} from 'utils/common';
import {validDate} from 'utils/validators';
import {formatDateForApi, getToday} from 'utils/datetime';

import './styles.css';

const formSubmit = (values, _dispatch, props) => {
  const {room, startDate, endDate, reason, notes} = values;
  const {locationRef} = props;

  const extraActions = [
    () => closeModal(MODALS.CREATE_OFFLINE_PERIOD),
    () => fetchAllocations({locationRef}),
    () => fetchAllocationStatistics({locationRef})
  ];

  props.requiresPermission(
    {
      locationRef,
      permission: PERMISSIONS.CREATE_DELETE_OFFLINE_PERIOD
    },
    () =>
      props.createOfflinePeriod(
        {
          room: _.get(room, 'value'),
          startDate: formatDateForApi(startDate),
          endDate: formatDateForApi(endDate),
          reason: _.get(reason, 'value'),
          locationRef,
          notes
        },
        extraActions
      )
  );
};

const buildRoomOption = room => ({
  label: room.roomNumber,
  value: room.roomId
});

class CreateOfflinePeriodForm extends React.Component<any> {
  componentDidMount() {
    const extraActions = [
      offlinePeriodReasons =>
        storeDataInModal({
          modalName: MODALS.CREATE_OFFLINE_PERIOD,
          data: {
            offlinePeriodReasons
          }
        })
    ];
    this.props.fetchOfflinePeriodReasons(extraActions);
  }

  render() {
    const {className, handleSubmit, error, offlinePeriodReasons} = this.props;

    return (
      <form
        onSubmit={handleSubmit}
        className={classNames(className, 'CreateOfflinePeriodForm')}>
        {error && <ErrorBlock>{error}</ErrorBlock>}

        <FormField>
          <LabelV2>Room number</LabelV2>
          <Field
            name="room"
            className="ooo_roomNo"
            component={SelectField}
            disabled={true}
          />
        </FormField>
        <div className="dates">
          <FormField>
            <LabelV2>Start date</LabelV2>
            <Field
              name="startDate"
              className="ooo_startDate"
              component={DateField}
              validate={[validDate]}
            />
          </FormField>

          <FormField>
            <LabelV2>End date</LabelV2>
            <Field
              name="endDate"
              className="ooo_endDate"
              component={DateField}
              validate={[validDate]}
            />
          </FormField>
        </div>

        <FormField>
          <LabelV2>Out of order reasons</LabelV2>
          <Field
            name="reason"
            className="ooo_reason"
            component={SelectField}
            {...{options: offlinePeriodReasons}}
            {...{options: offlinePeriodReasons}}
          />
        </FormField>

        <FormField>
          <LabelV2>Details</LabelV2>
          <Field
            name="notes"
            className="ooo_details"
            placeholder="Please enter notes"
            component={TextField}
          />
        </FormField>
      </form>
    );
  }
}

const mapStateToProps = state => {
  const modal = selectModal(state, MODALS.CREATE_OFFLINE_PERIOD);

  const offlinePeriodReasons = _.get(modal, 'data.offlinePeriodReasons', []);

  return {
    initialValues: {
      startDate: getToday(),
      room: buildRoomOption(_.get(modal, 'data.room')),
      reason: headOption(offlinePeriodReasons, buildOfflinePeriodReasonOption)
    },
    offlinePeriodReasons: offlinePeriodReasons.map(
      buildOfflinePeriodReasonOption
    ),
    locationRef: _.get(modal, 'data.locationRef')
  };
};

const mapDispatchToProps = {
  fetchOfflinePeriodReasons,
  createOfflinePeriod,
  requiresPermission
};

export default connect(mapStateToProps, mapDispatchToProps)(
  reduxForm({
    form: 'createOfflinePeriod',
    onSubmit: formSubmit,
    enableReinitialize: true
  })(CreateOfflinePeriodForm)
);
